/* esm.sh - react-remove-scroll@2.7.2/dist/es2015/medium */
import{createSidecarMedium as e}from"use-sidecar";var a=e();export{a as effectCar};
//# sourceMappingURL=medium.mjs.map